var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"ma-0 pa-0 d-block"},[_c('div',[_c('apexchart',{attrs:{"type":"bar","options":_vm.chartOptions,"series":_vm.series,"height":"400","width":"100%"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }